export const GLOBAL_PARSING_RULES_RESET_STATE = 'GLOBAL_PARSING_RULES_RESET_STATE';
export const GLOBAL_PARSING_RULES_CURRENT_ITEM = 'GLOBAL_PARSING_RULES_CURRENT_ITEM';

export const GLOBAL_PARSING_RULES_REQUEST_LOADING = 'GLOBAL_PARSING_RULES_REQUEST_LOADING';
export const GLOBAL_PARSING_RULES_REQUEST_SUCCESS = 'GLOBAL_PARSING_RULES_REQUEST_SUCCESS';
export const GLOBAL_PARSING_RULES_REQUEST_FAILED = 'GLOBAL_PARSING_RULES_REQUEST_FAILED';

export const GLOBAL_PARSING_RULES_CURRENT_ACTION = 'GLOBAL_PARSING_RULES_CURRENT_ACTION';
export const GLOBAL_PARSING_RULES_RESET_ACTION = 'GLOBAL_PARSING_RULES_RESET_ACTION';